import ReactCountryFlag from "react-country-flag";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

// City → Country name map
const CITY_TO_COUNTRY = {
  // United States
  "New York": "United States",
  "Los Angeles": "United States",
  "Chicago": "United States",
  "San Francisco": "United States",
  "Miami": "United States",
  "Boston": "United States",
  "Houston": "United States",
  "Las Vegas": "United States",
  "Austin": "United States",
  "Seattle": "United States",
  "Denver": "United States",
  "Nashville": "United States",
  
  // United Kingdom
  "London": "United Kingdom",
  "Manchester": "United Kingdom",
  "Liverpool": "United Kingdom",
  "Edinburgh": "United Kingdom",
  "Glasgow": "United Kingdom",
  "Birmingham": "United Kingdom",
  "Bristol": "United Kingdom",
  
  // France
  "Paris": "France",
  "Lyon": "France",
  "Marseille": "France",
  "Nice": "France",
  "Toulouse": "France",
  "Cannes": "France",
  
  // Germany
  "Berlin": "Germany",
  "Munich": "Germany",
  "Hamburg": "Germany",
  "Frankfurt": "Germany",
  "Cologne": "Germany",
  "Düsseldorf": "Germany",
  
  // Spain
  "Madrid": "Spain",
  "Barcelona": "Spain",
  "Valencia": "Spain",
  "Seville": "Spain",
  "Granada": "Spain",
  
  // Italy
  "Rome": "Italy",
  "Milan": "Italy",
  "Venice": "Italy",
  "Florence": "Italy",
  "Naples": "Italy",
  "Turin": "Italy",
  
  // Canada
  "Toronto": "Canada",
  "Vancouver": "Canada",
  "Montreal": "Canada",
  "Ottawa": "Canada",
  "Calgary": "Canada",
  
  // Mexico
  "Mexico City": "Mexico",
  "Cancún": "Mexico",
  "Guadalajara": "Mexico",
  
  // Brazil
  "São Paulo": "Brazil",
  "Rio de Janeiro": "Brazil",
  "Brasília": "Brazil",
  "Salvador": "Brazil",
  
  // Argentina
  "Buenos Aires": "Argentina",
  "Córdoba": "Argentina",
  
  // Australia
  "Sydney": "Australia",
  "Melbourne": "Australia",
  "Brisbane": "Australia",
  "Perth": "Australia",
  "Gold Coast": "Australia",
  
  // New Zealand
  "Auckland": "New Zealand",
  "Wellington": "New Zealand",
  "Christchurch": "New Zealand",
  
  // South Africa
  "Cape Town": "South Africa",
  "Johannesburg": "South Africa",
  "Durban": "South Africa",
  
  // Japan
  "Tokyo": "Japan",
  "Osaka": "Japan",
  "Kyoto": "Japan",
  "Tokyo": "Japan",
  "Yokohama": "Japan",
  "Sapporo": "Japan",
  
  // South Korea
  "Seoul": "South Korea",
  "Busan": "South Korea",
  "Incheon": "South Korea",
  "Daegu": "South Korea",
  
  // China
  "Beijing": "China",
  "Shanghai": "China",
  "Guangzhou": "China",
  "Shenzhen": "China",
  "Chengdu": "China",
  "Hangzhou": "China",
  
  // India
  "Mumbai": "India",
  "New Delhi": "India",
  "Delhi": "India",
  "Bangalore": "India",
  "Hyderabad": "India",
  "Kolkata": "India",
  "Pune": "India",
  "Chennai": "India",
  
  // Southeast Asia
  "Bangkok": "Thailand",
  "Ho Chi Minh City": "Vietnam",
  "Hanoi": "Vietnam",
  "Manila": "Philippines",
  "Jakarta": "Indonesia",
  "Kuala Lumpur": "Malaysia",
  "Taipei": "Taiwan",
  "Hong Kong": "Hong Kong",
  "Macau": "Macau",
  "Singapore": "Singapore",
  
  // Middle East & West Asia
  "Dubai": "United Arab Emirates",
  "Abu Dhabi": "United Arab Emirates",
  "Istanbul": "Turkey",
  "Ankara": "Turkey",
  "Tel Aviv": "Israel",
  "Jerusalem": "Israel",
  "Cairo": "Egypt",
  "Dubai": "United Arab Emirates",
  "Doha": "Qatar",
  "Riyadh": "Saudi Arabia",
  "Jeddah": "Saudi Arabia",
  "Kuwait City": "Kuwait",
  "Baghdad": "Iraq",
  
  // Eastern Europe
  "Moscow": "Russia",
  "St. Petersburg": "Russia",
  "Warsaw": "Poland",
  "Prague": "Czech Republic",
  "Budapest": "Hungary",
  "Bucharest": "Romania",
  "Sofia": "Bulgaria",
  "Lisbon": "Portugal",
  "Krakow": "Poland",
  "Wrocław": "Poland",
  
  // Nordic & Scandinavian
  "Stockholm": "Sweden",
  "Copenhagen": "Denmark",
  "Oslo": "Norway",
  "Helsinki": "Finland",
  "Reykjavik": "Iceland",
  
  // Benelux & Other Europe
  "Amsterdam": "Netherlands",
  "Brussels": "Belgium",
  "Antwerp": "Belgium",
  "Rotterdam": "Netherlands",
  "Geneva": "Switzerland",
  "Zurich": "Switzerland",
  "Vienna": "Austria",
  "Prague": "Czech Republic",
  "Athens": "Greece",
  
  // Caribbean & Americas
  "Nassau": "Bahamas",
  "Kingston": "Jamaica",
  "Havana": "Cuba",
  "San Juan": "Puerto Rico",
};

const emojiToCountryCode = (emoji) => {
  const codePoints = [...emoji].map(
    char => char.codePointAt(0) - 127397
  );

  return String.fromCharCode(...codePoints);
};

const resolveCountryCode = (city, countryCode) => {
  if (
    countryCode &&
    [...countryCode].length === 2 &&
    /[\u{1F1E6}-\u{1F1FF}]/u.test(countryCode)
  ) {
    return emojiToCountryCode(countryCode);
  }
  // Alpha-2 code (e.g. "US", "GB") → use directly
  if (countryCode?.length === 2) return countryCode.toUpperCase();

  // Alpha-3 code (e.g. "USA", "GBR") → convert to alpha-2
  if (countryCode?.length === 3) {
    return countries.alpha3ToAlpha2(countryCode.toUpperCase()) || null;
  }

  // Fall back to city → country name → alpha-2 code
  if (city) {
    const countryName = CITY_TO_COUNTRY[city];
    if (countryName) {
      return countries.getAlpha2Code(countryName, "en") || null;
    }
  }

  return null;
};

const CountryFlag = ({
  city,
  countryCode,
  showName = true,
  svg = true,
  flagSize = "4em",
  style = {},
}) => {
  const resolvedCode = resolveCountryCode(city, countryCode);
  const displayName = city || countries.getName(resolvedCode, "en") || countryCode;

  if (!resolvedCode) {
    return showName ? <span style={style}>{displayName}</span> : null;
  }
  console.log('flag', resolvedCode, displayName)

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        ...style,
      }}
    >
      <ReactCountryFlag
        countryCode={resolvedCode}
        svg={svg}
        style={{ width: flagSize, height: flagSize }}
        title={displayName}
        aria-label={displayName}
      />
      {showName && <span>{displayName}</span>}
    </span>
  );
};

export default CountryFlag;